// extracted by mini-css-extract-plugin
export default {"tag":"tag-with-icon_tag__yYUlQ","tagIcon":"tag-with-icon_tagIcon__iZ3Qy"};